import decodeJwt from 'jwt-decode';
import Cookies from 'universal-cookie';
const cookies = new Cookies();
const options = {
    doNotParse: false,
};
const getImpersonationData = (environment) => cookies.get(`${environment}-impersonation`, options);
const decodeImpersonationToken = (impersonationToken) => decodeJwt(impersonationToken);
const canImpersonate = (impersonator, impersonationTokenProps) => impersonator.userId === impersonationTokenProps.impersonatorId;
const getImpersonateAuthProps = (authProps, environment) => {
    const impersonationData = getImpersonationData(environment);
    if (!impersonationData) {
        return null;
    }
    const impersonationToken = impersonationData.token;
    const impersonationProps = decodeImpersonationToken(impersonationToken);
    if (!impersonationProps || !canImpersonate(authProps, impersonationProps)) {
        return null;
    }
    const { userId, companyId, exp } = impersonationProps;
    return {
        token: authProps.token,
        userId,
        companyId,
        impersonationToken,
        exp,
    };
};
const clearImpersonationToken = (environment, redirect = true) => {
    const hostname = window.location.hostname.split('.');
    const domain = hostname[hostname.length - 2];
    const tld = hostname[hostname.length - 1];
    const impersonateData = getImpersonationData(environment);
    const originUrl = impersonateData.origin;
    cookies.remove(`${environment}-impersonation`, {
        domain: `.${domain}.${tld}`,
        path: '/',
        secure: true,
        sameSite: true,
    });
    if (redirect) {
        window.location.replace(originUrl);
    }
};
export { canImpersonate, getImpersonateAuthProps, clearImpersonationToken };
//# sourceMappingURL=impersonateHelper.js.map